var map = {
	"./partners-brand-1.webp": 368,
	"./partners-brand-10.webp": 5874,
	"./partners-brand-11.webp": 5261,
	"./partners-brand-12.webp": 6845,
	"./partners-brand-2.webp": 9387,
	"./partners-brand-3.webp": 7130,
	"./partners-brand-4.webp": 1835,
	"./partners-brand-5.webp": 2770,
	"./partners-brand-6.webp": 4130,
	"./partners-brand-7.webp": 8559,
	"./partners-brand-8.webp": 31,
	"./partners-brand-9.webp": 5012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7778;